import script from "./NotionWorkspaceView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotionWorkspaceView.vue?vue&type=script&setup=true&lang=js"

import "./NotionWorkspaceView.vue?vue&type=style&index=0&id=31771856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31771856"]])

export default __exports__